var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('q-icon',{attrs:{"name":_vm.getCardTypeIcon(_vm.cardType),"size":_vm.size}}),(_vm.withName)?_c('div',{staticClass:"q-pa-sm"},[_vm._v(_vm._s(_vm.getCardTypeName(_vm.cardType)))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }